import React, { useEffect, useRef } from 'react';

type Event = MouseEvent | TouchEvent;

const useClickOutSide = (
  setShow: React.Dispatch<React.SetStateAction<boolean>>,
) => {
  const componentRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handler = (event: Event) => {
      if (componentRef.current) {
        if (!componentRef.current.contains(event.target as Node)) {
          setShow(false);
        }
      }
    };
    document.addEventListener('mousedown', handler);
    return () => {
      document.removeEventListener('mousedown', handler);
    };
  });

  return { componentRef };
};

export default useClickOutSide;
